import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';

const cdnUrl = environment.cdnUrl;

@Injectable({ providedIn: 'root' })
export class VenueConfigService {
  constructor(private http: HttpClient) {}

  getVenueConfig(id: any) {
    return this.http.get(`${cdnUrl}/${id}.json`);
  }
}
